import React from "react";
import { Item, ItemStatuses, ItemTypes } from "../../data/ItemOfBusiness";
import { statusChipClass } from "../meetingcommon/BusinessItemCard";
import { editorNames, useOtherEditors } from "./itemEditing";

/** "✎ Jane Smith" next to an item someone else has open in an editor */
function EditingBadge({ subId }: { subId: string }) {
  const editors = useOtherEditors(subId);
  if (editors.length === 0) return null;
  return (
    <span className="sl-chip sl-chip-editing ms-2" title={`${editorNames(editors)} editing now`}>
      ✎ {editorNames(editors)}
    </span>
  );
}

export interface ItemsListProps {
  list: Item[];
  onEdit: (item: Item) => void;
  onAmendItem: (item: Item) => void;
  setCurrentMeetingItem: (item: Item) => void;
  isAdmin: boolean;
}

function ItemsList({ list, onEdit, onAmendItem, setCurrentMeetingItem, isAdmin }: ItemsListProps) {
  return (
    <div className="table-responsive">
      <table className="table">
        <thead>
          <tr>
            <th>Code</th>
            {isAdmin ? <th>Order</th> : <></>}
            <th>Type</th>
            <th>Status</th>
            <th>Name</th>
            <th>Votes (total | for | against | abstain)</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {list ? (
            list.map((item) => {
              let votes = item.voteCounts.length === 4 ? item.voteCounts[3] : null;
              return (
                <tr key={item.subId}>
                  <td className="sl-num">{item.code}</td>
                  {isAdmin ? <td className="sl-num">{item.order}</td> : <></>}
                  <td>{item.type}</td>
                  <td>
                    <span className={`sl-chip ${statusChipClass(item.status)}`}>{item.status}</span>
                  </td>
                  <td style={{ maxWidth: "300px" }} title={item.code + "\n\n" + item.text}>
                    {item.heading}
                    <EditingBadge subId={item.subId} />
                  </td>
                  <td className="sl-num">{votes ? `${votes.total} | +${votes.votesFor} | −${votes.votesAgainst} | =${votes.votesAbstain}` : ""}</td>
                  <td className="text-nowrap">
                    {(item.type === ItemTypes.OriginalMotion && item.status === ItemStatuses.New) || isAdmin ? (
                      <button className="btn btn-light btn-sm me-1" onClick={() => onEdit(item)}>
                        Edit
                      </button>
                    ) : (
                      <></>
                    )}
                    <button className="btn btn-primary btn-sm me-1" onClick={() => setCurrentMeetingItem(item)}>
                      Set as Meeting Item
                    </button>
                    <button className="btn btn-light btn-sm" onClick={() => onAmendItem(item)}>
                      Create Amendment
                    </button>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={7}>Could not request Items list</td>
            </tr>
          )}
          {list && list.length === 0 ? (
            <tr>
              <td colSpan={7} className="text-muted">
                No Items found
              </td>
            </tr>
          ) : (
            <></>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default ItemsList;
